<!-- Minimized bar: fixed bottom-right -->
@if (minimized()) {
    <div
        class="fixed bottom-4 right-4 z-[10000] bg-shui-base-3 border border-shui-base-4 rounded-md px-4 py-2 flex items-center gap-3 cursor-pointer shadow-lg hover:bg-shui-base-4 transition-colors"
        (click)="maximize()"
    >
        <span class="text-sm text-shui-text-strong font-semibold truncate max-w-[200px]">{{
            heading() | translate
        }}</span>
        <sh-button icon="arrow-line-up-s" layout="normal" color="secondary" size="s"></sh-button>
    </div>
}

<!-- Full dialog -->
@if (!minimized()) {
    <div cdkDrag cdkDragBoundary=".cdk-overlay-pane" class="bg-shui-base-3 rounded-md" [style.width]="width()">
        <header
            cdkDragHandle
            class="flex items-center justify-between border-solid border-0 border-b-2 border-b-shui-base-4 p-4 cursor-move"
        >
            <span class="text-base text-shui-text-strong font-semibold">{{ heading() | translate }}</span>
            <div class="flex items-center gap-1">
                <sh-button
                    (click)="minimize()"
                    icon="arrow-line-down-s"
                    layout="normal"
                    color="secondary"
                    size="s"
                ></sh-button>
                <sh-button (click)="onCancel()" icon="cancel" layout="normal" color="secondary" size="s"></sh-button>
            </div>
        </header>

        <main class="p-4 flex flex-col gap-4">
            @if (description()) {
                <p class="text-sm text-shui-text-strong m-0">{{ description()! | translate }}</p>
            }
            <ng-content></ng-content>
        </main>

        <div class="flex justify-end items-center gap-2 p-4">
            <sh-button
                [label]="cancelLabel() | translate"
                layout="normal"
                color="secondary"
                size="max-content"
                (click)="onCancel()"
            ></sh-button>
            <sh-button
                [label]="confirmLabel() | translate"
                layout="normal"
                size="max-content"
                [disabled]="confirmDisabled()"
                (click)="onConfirm()"
            ></sh-button>
        </div>
    </div>
}
